export default "__VITE_PUBLIC_ASSET__d4d08d52__"